import createDataContext from './createDataContext'

const modalReducer = (state, action) => {
  const { type, payload } = action

  switch (type) {
    case 'set_children':
      return { ...state, component: payload.component, title: payload.title }
    case 'open':
      return {
        ...state,
        hidden: false,
      }
    case 'close':
      return { ...state, hidden: true }
    default:
      return state
  }
}

const openModal = dispatch => async (title, component) => {
  dispatch({ type: 'set_children', payload: { component, title } })
  dispatch({ type: 'open' })
}

const closeModal = dispatch => async () => {
  dispatch({ type: 'close' })
}

export const { Provider, Context } = createDataContext(
  modalReducer,
  {
    openModal,
    closeModal,
  },
  { hidden: true, component: '', title: '' }
)
